<template>
    <div class="head_cont">
        <div class="head_box">
            <div class="head_left" v-if="headState == 1" @click="back()">
                <img class="head_logo" src="@/assets/tab/gb.png" alt="">
            </div>
            <div class="head_left" v-else></div>
            {{ title }}
            <div class="head_left"></div>
        </div>
        <div style="height: 60px;"></div>
    </div>
</template>

<script>
export default {
    name: "HeaderIndex",
    props: ['headState', 'title', 'backState'],
    data() {
        return {
            windowWidth: window.innerWidth,
        };
    },
    watch: {
        windowWidth() {
            this.windowWidth = window.innerWidth;
            this.fullClick();
        },
    },
    mounted() {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        const that = this;
        that.fullClick();
        window.addEventListener("resize", that.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.fullClick();
        },
        fullClick() {
            if (this.windowWidth > 1055) {
                window.location.reload();
            }
        },
        back() {
            if(this.backState == 1) {
                if (window.history.length > 1) {
                    window.history.go(-1); // 有上一页则返回
                } else {
                    window.location.href = "/"; // 没有上一页则跳转首页
                }
            }else {
                if(localStorage.getItem('accountType') == 1) {
                    this.$router.push({ path: '/my' });
                }else {
                    this.$router.push({ path: '/counselor' });
                }
            }
        }
    }
};
</script>

<style scoped lang="less">
* {
    margin: 0;
    padding: 0;
}
.head_cont {
    width: 100%;
}
.head_box {
    width: calc(100% - 20px);
    padding: 0 10px;
    height: 56px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;

    .head_left {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;

        .head_logo {
            width: 14px;
            object-fit: contain;
            margin-top: 5px;
        }
    }
}
</style>